<div mat-dialog-title class="flex-row flex-align-center desktop-dialog">
    <img id="dialogLogoDN" [src]="infoLogoDn" [alt]="'logo'" />
    <div class="dialog-title" style="flex: 1; text-align: center;">{{ getPermissionTitle() }}</div>
</div>
<div mat-dialog-title class="flex-row flex-align-center mobile-dialog">
    <div class="dialog-title" style="flex: 1; text-align: center;">{{ getPermissionTitle() }}</div>
    <img id="dialogLogoDN" [src]="infoLogoDn" [alt]="'logo'" />
</div>

<hr class="dialog-title-separator" />

<div class="flex-col">
    <section class="login-form">
        @if ( [ PermissionVisualizationType.Signin, PermissionVisualizationType.UserSessionExpired ].includes(permissionType()) ) {
        <mat-dialog-content>
            <dottnet-form-signin (formEventEmitter)="onPost($event)" [permissionType]="permissionType()" [passwordRetrieved]="passwordRetrieved()" (closeDialogEmitter)="closeDialog()" (pwdEventEmitter)="onRetrievePassword($event)"></dottnet-form-signin>
        </mat-dialog-content>
        } @if ( permissionType() !== PermissionVisualizationType.Signin && permissionType() !== PermissionVisualizationType.UserSessionExpired ) {
        <mat-dialog-content>
            <p>
                {{ getPermissionBody() }}
            </p>
        </mat-dialog-content>
        }
    </section>
</div>
